<p>view-child-course-history works!</p>
